import { render, staticRenderFns } from "./DecideComponent.vue?vue&type=template&id=daeae25a&scoped=true&"
import script from "./DecideComponent.vue?vue&type=script&lang=js&"
export * from "./DecideComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daeae25a",
  null
  
)

export default component.exports